import React, { Component } from 'react';
import PropTypes from 'prop-types';
import RegistryCollectionItemTileActions from './RegistryCollectionItemTileActions';
import ProductPrice from '../product/ProductPrice';

const GROUP_GIFT_COPY = 'Contribute any amount you choose towards this gift. If the gift is not completed by the wedding date, the couple will receive all the funds.';

class RegistryCollectionItemTile extends Component {
  constructor(props) {
    super(props);

    this.updateQuantity = this.updateQuantity.bind(this);
    this.showProductModal = this.showProductModal.bind(this);
    this.addToCart = this.addToCart.bind(this);
    this.handleMouseOver = this.handleMouseOver.bind(this);
    this.handleMouseOut = this.handleMouseOut.bind(this);
    this.redirectToPdp = this.redirectToPdp.bind(this);

    this.state = {
      quantity: 1,
      quickviewAnimating: false,
      quickviewHasLeft: true,
      quickviewTimeout: null,
      quickviewStyle: {
        visibility: 'hidden',
        height: 0
      },
      isHovering: false
    };
  }

  handleMouseOver() {
    this.setState({ isHovering: true });
  }

  handleMouseOut() {
    this.setState({ isHovering: false });
  }

  updateQuantity(event) {
    this.setState({
      quantity: event.target.value
    });
  }

  showProductModal() {
    const { collectionItem, onShowProduct } = this.props;
    onShowProduct(collectionItem);
  }

  redirectToPdp(e) {
    const { collectionItem } = this.props;
    e.stopPropagation();
    if (e.currentTarget && e.currentTarget.name !== 'buy-now') {
      // for IE 10
      let origin = window.location.origin;
      if (!origin) {
        origin = `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}`;
        if (window.location.pathname[0] !== '/') {
          origin = `/${origin}`;
        }
      }
      const oldUrl = `${origin}${window.location.pathname}`;
      const newUrl = `/registry/collection-item/${collectionItem.object_id}?from-wedding-website=true&referer=${oldUrl}&scroll=${window.pageYOffset}`;
      window.location.href = newUrl;
    }
  }

  addToCart() {
    const { collectionItem, onAddToCart } = this.props;
    const { quantity } = this.state;

    onAddToCart(collectionItem, quantity).catch((e) => {
      if (e.response.errorData) {
        if (e.response.errorData.isGroupGift) {
          this.setState({
            contribution: e.response.errorData.maxContribution
          });
        }
        if (e.response.errorData.maxContribution > 0) {
          this.setState({ quantity: e.response.errorData.maxContribution });
        } else if (e.response.errorData.availableQuantity > 0) {
          this.setState({ quantity: e.response.errorData.availableQuantity });
        }
      }
    });
  }

  toggleQuickview(isActive) {
    const { quickviewTimeout, quickviewHasLeft } = this.state;
    if (isActive) {
      clearTimeout(quickviewTimeout);
      if (!quickviewHasLeft) {
        return;
      }

      this.setState({
        quickviewHasLeft: false,
        quickviewAnimating: true,
        quickviewStyle: {
          visibility: 'visible',
          height: `${this.quickviewTrigger.scrollHeight}px`
        }
      });

      setTimeout(() => {
        this.setState({
          quickviewAnimating: false
        });
      }, 200);
    } else {
      setTimeout(() => {
        this.setState({
          quickviewAnimating: true,
          quickviewStyle: {
            height: '0px',
            visibility: 'visible'
          }
        });
        setTimeout(() => {
          this.setState({
            quickviewAnimating: false,
            quickviewHasLeft: true,
            quickviewStyle: {
              visibility: 'hidden',
              height: '0px'
            }
          });
        }, 200);
      }, 100);
    }
  }

  // Move this to a util
  truncateText(unsanitizedOriginalText, charLimit, ignoreWordBoundary) {
    // sanitize by trimming and removing consecutive spaces
    const originalText = unsanitizedOriginalText.trim().replace(/\s{2,}/g, ' ');

    if (charLimit < 3 || !originalText || originalText.length <= charLimit) {
      return originalText;
    }

    // if we're ignoring word boundaries, we don't have to do anything fancy
    // just chop it off at the limit and make sure we don't end with whitespace
    if (ignoreWordBoundary) {
      return `${originalText.substring(0, charLimit - 3).trim()}...`;
    }

    const truncatedText = originalText.substring(0, charLimit - 2); // subtract 3 to make room for ellipsis, but add 1 to catch whitespace if we happen to end on a word boundary
    const lastSpaceIndex = truncatedText.lastIndexOf(' ');

    if (lastSpaceIndex <= 0) {
      return `${truncatedText.substring(0, truncatedText.length - 1)}...`;
    }

    return `${truncatedText.substring(0, lastSpaceIndex)}...`;
  }

  render() {
    const { collectionItem } = this.props;
    const { quantity, isHovering } = this.state;

    if (collectionItem === null) return null;

    const productImage = collectionItem.images.length > 0 && collectionItem.images[0].medium;
    const isGroupGift = collectionItem.contributions.group_gift;
    const stillNeeds = collectionItem.contributions.still_needs;
    const isFulfilled = collectionItem.contributions.show_as_fulfilled;
    const isReserved = collectionItem.contributions.show_as_reserved;
    const canPurchase = collectionItem.actions && collectionItem.actions.purchase;
    const showContributions = !(!canPurchase || collectionItem.contributions.hide_contributions || isFulfilled || isReserved);
    const showQuickview = collectionItem.personal_note;
    const quickviewEvents = (showQuickview) ? {
      onMouseEnter: () => this.toggleQuickview(true),
      onMouseLeave: () => this.toggleQuickview(false)
    } : {};
    const showGroupGiftBadge = isGroupGift && !isFulfilled;
    const canQuickAdd = canPurchase && (
      (collectionItem.type === 'EXTERNAL' && collectionItem.cash_fund && !isGroupGift)
      || (collectionItem.type !== 'EXTERNAL' && !isGroupGift)
    );
    const showActions = !isFulfilled && !isReserved;

    // Replace these / move them up
    // const ridpUrl = '';

    const isFreeShip = collectionItem.free_shipping; /*
    collectionItem.shippable &&
    !collectionItem.delivery_surcharge &&
    !(isGroupGift && collectionItem.contributions.completed_units > 0);
    */

    // Promotional Badge
    let imageHostname = null;
    switch (window.zola.env) {
      case 'production':
        imageHostname = '//images.zola.com';
        break;
      case 'staging':
        imageHostname = '//stage-images.zola.com';
        break;
      default:
        imageHostname = 'localhost:9100/v2/image';
    }
    const badgeImageUrl = (window.zola.feature.productBadging && collectionItem.badge_uuid)
      ? `${imageHostname}/${collectionItem.badge_uuid}`
      : null;
    const hideProductInfo = (window.optimizelyProductInfoHover) ? 'product-info product-info-hide' : '';
    const revealProductInfo = (window.optimizelyProductInfoHover) ? 'product-info product-info-reveal' : '';

    return (
      <div className={`${(window.optimizelyProductInfoHover) ? 'shop-tile product-tile hoverable' : 'shop-tile product-tile'}`} {...quickviewEvents} onMouseOver={this.handleMouseOver} onMouseOut={this.handleMouseOut}>
        {showGroupGiftBadge && (
          <div className="shop-badge shop-badge-group-gift" data-tooltip={GROUP_GIFT_COPY} />
        )}
        {isFulfilled && (
          <div className="shop-badge-purchased-tile">
            <div className="shop-badge-purchased-tile__content">
              <i className="zolaicon zolaicon-checkmark" />
              <div>Purchased</div>
            </div>
          </div>
        )}
        {window.optimizelyProductInfoHover ? (
          <a role="button" className="pdp-link entity-image thumbnail thumbnail-square quickview-trigger">
            {(window.zola.feature.productBadging && collectionItem.badge_uuid && !showGroupGiftBadge && !isFulfilled) && (
              <div className="product-badge">
                <img src={badgeImageUrl} role="presentation" />
              </div>
            )}
            <img
              src={productImage}
              // onError="this.src = '/assets/images/no-image-available-400x400.jpg'"
              className={!canPurchase || isFulfilled ? 'discontinued' : ''}
              alt={collectionItem.name}
            />
          </a>
        ) : (
          <a role="button" className="pdp-link entity-image thumbnail thumbnail-square quickview-trigger" onClick={window.optimizelyOpenFullPagePdp ? (e) => { this.redirectToPdp(e); } : this.showProductModal}>
            {(window.zola.feature.productBadging && collectionItem.badge_uuid && !showGroupGiftBadge && !isFulfilled) && (
              <div className="product-badge">
                <img src={badgeImageUrl} role="presentation" />
              </div>
            )}
            <img
              src={productImage}
              // onError="this.src = '/assets/images/no-image-available-400x400.jpg'"
              className={!canPurchase || isFulfilled ? 'discontinued' : ''}
              alt={collectionItem.name}
            />
          </a>
        )}
        <div className={`${(isHovering) ? revealProductInfo : hideProductInfo}`}>
          <a role="button" className="block-link pdp-link" onClickCapture={window.optimizelyOpenFullPagePdp ? (e) => { this.redirectToPdp(e); } : this.showProductModal}>
            {showQuickview && (
              <div className={`quickview hidden-xs quickview-trigger${this.state.quickviewAnimating ? ' velocity-animating' : ''}`} style={this.state.quickviewStyle} ref={c => (this.quickviewTrigger = c)}>
                <div className={`${(window.optimizelyProductInfoHover && isHovering) ? 'hidden' : 'quickview-inputs-wrapper'}`}>
                  <div className="quote-circle">&rdquo;</div>
                  <span className="quote">{this.truncateText(collectionItem.personal_note, 150)}</span>
                </div>
              </div>
            )}
            <div className="shop-entity-details text-center">
              <h6 className="brand-name">{collectionItem.brand && collectionItem.brand.name}</h6>
              <h5 className="entity-name">{collectionItem.name}</h5>
              <div className="price-wrapper">
                {!isGroupGift && <h5 className="price"><ProductPrice sku={collectionItem} isTile /></h5>}
                {isGroupGift && !isFulfilled && <h5 className="price"><em>Contribute what you wish</em></h5>}
                {isFreeShip && !isFulfilled && canPurchase && <strong className="free-ship">FREE SHIPPING</strong>}
              </div>
            </div>
          </a>
          <div className="registry-actions">
            {isFulfilled && (
              <div className="center-block shop-badge shop-badge-fulfilled">
                <div className="shop-badge-fulfilled__text">purchased</div>
              </div>
            )}
            {isReserved && (
              <div className="center-block shop-badge shop-badge-on-hold" />
            )}
            {showActions && (
              <div className="input-group registry-item-actions">
                {canQuickAdd && (
                  <input
                    type="text"
                    className="form-control text-center qty"
                    name="quantity"
                    value={quantity}
                    onChange={(e) => { this.updateQuantity(e); }}
                  />
                )}
                <RegistryCollectionItemTileActions
                  collectionItem={collectionItem}
                  onAddToCart={this.addToCart}
                  onShowProduct={this.showProductModal}
                />
              </div>
            )}
          </div>
          <div className="contributions" onClickCapture={window.optimizelyOpenFullPagePdp ? (e) => { this.redirectToPdp(e); } : this.showProductModal}>
            {showContributions && (
              <span className="text-muted">
                {!isGroupGift && <span className="hidden-xs">Requested: {collectionItem.requested_quantity} &middot; </span>}
                Still Needs: {stillNeeds}
              </span>
            )}
          </div>
        </div>
      </div>
    );
  }
}

RegistryCollectionItemTile.propTypes = {
  collectionItem: PropTypes.shape({}),
  onAddToCart: PropTypes.func.isRequired,
  onShowProduct: PropTypes.func.isRequired
};

export default RegistryCollectionItemTile;



// WEBPACK FOOTER //
// ./src/components/registry/RegistryCollectionItemTile.jsx